'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _querychanges = require('./querychanges.component');

var _querychanges2 = _interopRequireDefault(_querychanges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var querychangesModule = _angular2.default.module('querychanges', [_angularUiRouter2.default]).component('querychanges', _querychanges2.default);

exports.default = querychangesModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/querychanges/querychanges.js